import React from "react";
import "./Css/Education.css";
import { getDatabase, get, child, ref, set } from "@firebase/database";
import props from "./ENV.json";
import Navbar from "./Essentials/Navbar";
import Footer from "./Essentials/Footer";
import { initializeApp } from "firebase/app";
import config from "./CONFIDENTIAL.js";
import { useLocation } from "react-router-dom";

const EnrollUser = () => {



  const app = initializeApp(config);
  if (
    document.getElementById("Name").value.length !== 0 &&
    document.getElementById("phone").value.length === 10 &&
    document.getElementById("enrollDate").value.length !== 0 &&
    document.getElementById("livesIn").value.length !== 0 &&
    document.getElementById("courseID").value !== "Select Course" &&
    document.getElementById("as").value !== "Your current status"
  ) {
    const getCourse = courseID => {
      if (courseID === "pyl4")
        return "Python";
      else if (courseID === "jpl3")
        return "Java";
      else if (courseID === "jsl4")
        return "Java Script";
      else if (courseID === "htm2")
        return "HTML";
      else if (courseID === "wad5")
        return "Web Application Development";
      else if (courseID === "rfw6")
        return "React JS (Frame work)";
      else if (courseID === "amd5")
        return "Android Application Development";
      else if (courseID === "cpl8")
        return "C Beginner friendly";
      else if (courseID === "djpy14")
        return "Django Python (Framework)";
      else if (courseID === "wad18")
        return "Fullstack + Spring";
      else if (courseID === "jsb17")
        return "Spring Boot";

    };
    var userDetails = {
      name: document.getElementById("Name").value.trim(),
      course: getCourse(document.getElementById("courseID").value.trim()),
      phone: document.getElementById("phone").value.trim(),
      status: document.getElementById("as").value.trim(),
      enrollDate: document.getElementById("enrollDate").value.trim(),
      livesIn: document.getElementById("livesIn").value.trim(),
      courseID: document.getElementById("c-id").innerHTML.split(":")[1].trim(),
      fee: document.getElementById("amount").innerHTML.trim()
    };
    get(child(ref(getDatabase()), `/Education`))
      .then(data => {
        if (data.exists()) {
          set(
            ref(getDatabase(), "Education/" + data.val().length),
            userDetails
          ).then(
            () => {
              alert(
                "Congratulations " +
                document.getElementById("Name").value.trim() +
                " you have successfully enrolled into " +
                getCourse(document.getElementById("courseID").value.trim()) +
                " course."
              );
              window.location.reload();
            },
            () => {
              alert("Oops!! please try again later");
            }
          );
        }
      })
      .catch(e => {
        alert("Try again later");
      });
  }
};

const selectCourse = () => {
  document.getElementById("c-id").innerHTML =
    "Course ID : " + document.getElementById("courseID").value;
  if (document.getElementById("courseID").value === "pyl4")
    document.getElementById("amount").innerHTML = 229 + "$";
  else if (document.getElementById("courseID").value === "jpl3")
    document.getElementById("amount").innerHTML = 199 + "$";
  else if (document.getElementById("courseID").value === "jsl4")
    document.getElementById("amount").innerHTML = 249 + "$";
  else if (document.getElementById("courseID").value === "htm2")
    document.getElementById("amount").innerHTML = 129 + "$";
  else if (document.getElementById("courseID").value === "wad5")
    document.getElementById("amount").innerHTML = 319 + "$";
  else if (document.getElementById("courseID").value === "rfw6")
    document.getElementById("amount").innerHTML = 329 + "$";
  else if (document.getElementById("courseID").value === "nfw6")
    document.getElementById("amount").innerHTML = 339 + "$";
  else if (document.getElementById("courseID").value === "dsj4")
    document.getElementById("amount").innerHTML = 299 + "$";
  else if (document.getElementById("courseID").value === "cpl8")
    document.getElementById("amount").innerHTML = 159 + "$";
  else if (document.getElementById("courseID").value === "djpy14")
    document.getElementById("amount").innerHTML = 319 + "$";
  else if (document.getElementById("courseID").value === "jsb17")
    document.getElementById("amount").innerHTML = 339 + "$";
  else if (document.getElementById("courseID").value === "wad18")
    document.getElementById("amount").innerHTML = 369 + "$";
};
const OverseasEducation = () => {


  const router = useLocation();

  var EduTemplate = {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center"
  };
  var EduTemplatePhone = {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center"
  };

  var leftTemp = {
    width: "50%"
  };
  var leftTempPhn = {
    width: "100%"
  };
  var rightTemp = {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  };
  var rightTempPhn = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  };
  return (
    <div>
      <Navbar />
      <br />
      <div
        id="Edu"
        style={window.screen.width > 900 ? EduTemplate : EduTemplatePhone}
      >
        <div style={window.screen.width > 900 ? leftTemp : leftTempPhn}>
          <table
            style={{
              borderSpacing: 0
            }}
            id="courseTemp"
          >
            <tr>
              <td />
              <td>
                <center>
                  <b>Course</b>
                </center>
              </td>
              <td>
                <center>
                  <b>Course ID</b>
                </center>
              </td>
              <td>
                <center>
                  <b>Fee</b>
                </center>
              </td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/c.png" />
              </td>
              <td>C Beginner friendly</td>
              <td>cpl8</td>
              <td>159$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/java.png" />
              </td>
              <td>Core Java</td>
              <td>jpl3</td>
              <td>199$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/python.png" />
              </td>
              <td>Python with ML</td>
              <td>pyl4</td>
              <td>229$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/dsa.svg" />
              </td>
              <td>DSA using Java</td>
              <td>dsj4</td>
              <td>299$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/html_css.png" />
              </td>
              <td>HTML & CSS</td>
              <td>htm2</td>
              <td>129$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/javascript.png" />
              </td>
              <td>JavaScript</td>
              <td>jsl4</td>
              <td>249$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/react.png" />
              </td>
              <td>React JS (Frame work)</td>
              <td>rfw6</td>
              <td>329$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/next.png" />
              </td>
              <td>Next JS (Frame work)</td>
              <td>nfw6</td>
              <td>339$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/react_django.png" />
              </td>
              <td>FullStack + Django</td>
              <td>wad5</td>
              <td>329$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/react_spring.png" />
              </td>
              <td>FullStack + Spring</td>
              <td>wad18</td>
              <td>369$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/springboot.png" />
              </td>
              <td>Spring Boot</td>
              <td>jsb17</td>
              <td>339$</td>
            </tr>
            <tr>
              <td>
                <img className="courses" src="education/django.png" />
              </td>
              <td>Django Python (Framework)</td>
              <td>djpy14</td>
              <td>319$</td>
            </tr>
          </table>
          <div id="features" style={{ padding: "10px", textAlign: "justify" }}>
            <br />
            <b>Course features</b> <br /> <br />
            <ol style={{ paddingLeft: "20px" }}>
              <li>
                One on one live class in online mode for one hour daily
              </li>{" "}
              <br />
              <li>
                No fixed amount of duration, you will be taught until you learn.
              </li>
              <br />
              <li>
                Learn up-to-date skills that are actually being used by top tech
                companies.
              </li>{" "}
              <br />
              <li>
                Clear your Doubts in Every class by directly talking to the
                Instructor.
              </li>{" "}
              <br />
              <li>
                You will be taught everything from very basic to advanced core
                programming
              </li>{" "}
              <br />
              <li>
                Get an amazing Machine learning project at the end of your
                course work.
              </li>
            </ol>
          </div>
        </div>
        <div
          id="newUser"
          style={window.screen.width > 900 ? rightTemp : rightTempPhn}
        >
          {window.screen.width > 750 &&
            <p style={{ fontSize: "1.2rem", marginBottom: "10px" }}>
              Register for courses
            </p>}
          <div>
            <input
              style={{
                fontSize: "1.1rem"
              }}
              id="Name"
              placeholder="Full name"
            />
            <br />
            <select
              style={{
                background: "white",
                color: "black"
              }}
              id="courseID"
              onClick={() => {
                document.getElementById("selected-option_").style.visibility =
                  "hidden";
              }}
              onChange={selectCourse}
            >
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="Select a course"
                id="selected-option_"
                selected
              >
                Select Course
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="cpl8"
              >
                C Beginner friendly
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="pyl4"
              >
                Python with Machine Learning
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="jpl3"
              >
                Core Java
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="jsl4"
              >
                JavaScript
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="dsj4"
              >
                Data Structures & Algorithms using Java
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="htm2"
              >
                HTML and CSS
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="rfw6"
              >
                React JS (Frame Work)
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="nfw6"
              >
                Next JS (Frame Work)
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="djpy14"
              >
                Django Python (Framework)
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="wad5"
              >
                FullStack + Django
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="wad18"
              >
                FullStack + Spring
              </option>
              <option
                style={{
                  background: "white",
                  color: "black"
                }}
                value="jsb17"
              >
                Spring Boot
              </option>
            </select>
            <br />
            <div className="phC">
              <input
                style={{
                  fontSize: "1.1rem"
                }}
                id="phone"
                placeholder="Phone number"
                type="number"
              />

              <select
                style={{
                  background: "white",
                  color: "black"
                }}
                id="as"
                onClick={() => {
                  document.getElementById("selected-option").style.visibility =
                    "hidden";
                }}
              >
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  id="selected-option"
                  selected
                >
                  Your current status
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  Pre-grad School
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  B.Tech
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  B.E
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  B.S (USA)
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  BSc
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  M.Tech
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  M.E
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  M.S (USA)
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Student"
                >
                  MSc
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Working"
                >
                  Working professional
                </option>
                <option
                  style={{
                    background: "white",
                    color: "black"
                  }}
                  value="Working"
                >
                  Other
                </option>
              </select>
            </div>
            <br />

            <p
              style={{
                fontSize: "0.97rem",
                textAlign: "center"
              }}
            >
              Date of enrolment
            </p>
            <input
              style={{
                fontSize: "1.1rem"
              }}
              id="enrollDate"
              type="date"
            />
            <br />
            <input
              style={{
                fontSize: "1.1rem"
              }}
              id="livesIn"
              type="text"
              placeholder="Country, State & City"
            />
          </div>
          <br />
          <p type="text" id="c-id">
            Course ID
          </p>
          <br />
          <p type="text" id="amount" placeholder="Amount">
            $
          </p>
          <br />
          <button
            style={{ cursor: "pointer" }}
            className="enroll"
            onClick={EnrollUser}
          >
            Enroll
          </button>
          <br />
          {localStorage.getItem("session-id") != undefined &&
            localStorage.getItem("session-id") ==
            process.env.REACT_APP_SESSION_ID &&
            <button
              style={{ cursor: "pointer" }}
              className="enroll students-data"
              onClick={() => {
                if (
                  localStorage.getItem("session-id") != undefined &&
                  localStorage.getItem("session-id") ==
                  process.env.REACT_APP_SESSION_ID
                ) {
                  window.open("enrolled-students", "_self");
                } else {
                  if (prompt("Enter the password") === props.key) {
                    window.open("enrolled-students", "_self");
                  }
                }
              }}
            >
              View Enrolled Students Data
            </button>}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default OverseasEducation;
